export default {
  'menu.welcome': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.settings': '個人設置',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.organization': '組織架構',
  'menu.user': '使用者管理',
  'menu.system': '系統管理',
  'menu.system.permission': '權限管理',
  'menu.system.role': '角色管理',
  'menu.system.tag': '標籤管理',
  'menu.system.calendar': '日曆管理',
  'menu.vacation': '假期管理',
  'menu.vacation.balance': '假期餘額',
  'menu.vacation.quota': '額度配置',
  'menu.vacation.expiry': '有效期',
  'menu.approval': '審批管理',
  'menu.approval.templates': '審批模板',
  'menu.approval.applications': '審批申請',
  'menu.approval.submit': '發起審批',
  'menu.vehicle': '公車管理',
  'menu.vehicle.applications': '公車使用記錄',
  'menu.vehicle.refuelRecords': '加油記錄',
  'menu.vehicle.repairApplications': '車輛維修記錄',
  'menu.shift': '排班管理',
  'menu.profile': '員工檔案',
  'menu.test': '測試模組',
};
